<template>
    <button
        type="reset"
        class="btn btn-outline-secondary"
        :disabled="disabled"
    >
        <slot>{{ $t('button.reset') }}</slot>
    </button>
</template>

<script setup lang="ts">

const { disabled = false } = defineProps<{
    disabled?: boolean
}>()
</script>

<style scoped>

</style>
